/* eslint-disable no-console */
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const fpPromise = FingerprintJS.load().catch(error => {
  console.error('Error loading FingerprintJS:', error);
  return null;
});

const sanitizeFingerprint = fingerprint => {
  if (!fingerprint || typeof fingerprint !== 'object') return fingerprint;

  const { components } = fingerprint;
  if (!components || typeof components !== 'object') return fingerprint;

  const safeComponents = { ...components };
  delete safeComponents.webGlExtensions;
  delete safeComponents.canvas;
  delete safeComponents.math;

  return {
    ...fingerprint,
    components: safeComponents,
  };
};

export async function getFingerprint() {
  try {
    const fp = await fpPromise;
    if (!fp) return null;
    const fingerprint = await fp.get();
    return sanitizeFingerprint(fingerprint);
  } catch (error) {
    console.error('Error fetching FingerprintJS', error);
    return null;
  }
}
